import React from 'react';
import { TitleAndValue } from '../TitlesAndTexts/TitleAndValueList';
import { Material } from '../../../sp-types/materialType';
import { ExpandCircleDownOutlined } from '@mui/icons-material';

export interface IDataItem {
  title: string;
  valueAsString: string;
  suffix?: string;
  size?: number;
}

export interface MaterialDataCardProps {
  materialColorDictionary: Record<string, string>;
  materialsMap: Record<string, Material>;
  materialsData: {
    materialId: string;
    expanded?: boolean;
    materialNameSize?: number;
    data: (React.ReactNode | string | IDataItem)[];
  }[];
  title?: string;
  onExpandToggle?: (_materialId: string) => void;
  children?: React.ReactNode;
}
export const MaterialDataCard: React.FC<MaterialDataCardProps> = ({
  materialsMap,
  materialColorDictionary,
  materialsData,
  title,
  onExpandToggle,
  children,
}) => {
  return (
    <div className="flex flex-col max-h-full overflow-auto space-y-1 ">
      {title && <h6 className="text-red text-lg">{title}</h6>}
      {materialsData.map((material, index) => (
        <React.Fragment key={index}>
          <div
            style={{
              borderLeft: `8px solid ${materialColorDictionary[material.materialId]} `,
            }}
            className={`flex justify-between gap-5 px-3  border-t border-r  border-b border-gray-100 items-center min-h-14 ${
              onExpandToggle ? 'cursor-pointer' : ''
            }`}
            key={index}
            onClick={() => onExpandToggle && onExpandToggle(material.materialId)}
          >
            {onExpandToggle && (
              <div className={`text-blue-600 cursor-pointer ${material.expanded ? '' : '-rotate-90'}`}>
                <ExpandCircleDownOutlined />
              </div>
            )}
            <div style={{ width: material.materialNameSize }} className="  overflow-hidden">
              <TitleAndValue
                titleValueData={[{ title: 'Material', valueAsString: materialsMap[material.materialId].name }]}
              />
            </div>

            {material.data.map((item, itemIndex) => (
              <div key={itemIndex} className="">
                {typeof item === 'object' && 'title' in item! && 'valueAsString' in item ? (
                  <div style={{ width: item.size }}>
                    <TitleAndValue titleValueData={[item]} />{' '}
                  </div>
                ) : (
                  item
                )}
              </div>
            ))}
          </div>
          {material.expanded && children}
        </React.Fragment>
      ))}
    </div>
  );
};
